(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.isSesseqHome = document.body.classList.contains('sesseq-home');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      if (this.isSesseqHome) this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.isSesseqHome) {
        this.header.classList.toggle('sesseq-header-scrolled', scrollTop > 32);
        this.header.classList.remove('shopify-section-header-hidden');
        this.setHeaderHeight();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sesseq-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sesseq-category-carousel')) {
    customElements.define('sesseq-category-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.scc__track');
        this.controls = this.querySelector('.scc__controls');
        this.buttons = [...this.querySelectorAll('[data-direction]')];
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
        if (this.dataset.magazineUrl) this.loadMagazine();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
      async loadMagazine() {
        const controller = this.abort;
        const sourceUrl = new URL(this.dataset.magazineUrl, window.location.origin);
        if (sourceUrl.origin !== window.location.origin) return;
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) sourceUrl.searchParams.set('preview_theme_id', previewTheme);
        try {
          const response = await fetch(sourceUrl.href, { credentials: 'same-origin', cache: 'no-cache', signal: controller.signal });
          if (!response.ok) return;
          const source = new DOMParser().parseFromString(await response.text(), 'text/html');
          const template = source.querySelector('template[data-sesseq-mood-cards]');
          if (!template || controller.signal.aborted || !this.isConnected) return;
          const cards = template.content.cloneNode(true);
          if (!cards.querySelector('.scc__card')) return;
          if (this.dataset.magazineLinkLabel) {
            cards.querySelectorAll('[data-mood-link-label]').forEach(label => { label.textContent = this.dataset.magazineLinkLabel; });
          }
          this.track.replaceChildren(cards);
          this.track.scrollLeft = 0;
          this.dataset.magazineLoaded = 'true';
          this.update();
        } catch (error) {
          if (!controller.signal.aborted) this.dataset.magazineLoaded = 'unavailable';
        }
      }
      move(direction) {
        const card = this.track.querySelector('.scc__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.buttons[0].disabled = this.track.scrollLeft < 2;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sesseq-product-in-style"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sesseq-product-styles')) {
    customElements.define('sesseq-product-styles', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
      }

      initialize() {
        this.track = this.querySelector('[data-style-track]');
        this.controls = this.querySelector('[data-style-controls]');
        if (!this.track || !this.controls) return;
        this.previous = this.querySelector('[data-style-previous]');
        this.next = this.querySelector('[data-style-next]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', schedule, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * this.direction());
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.direction() * this.maximum(), behavior: this.behavior() });
          }
        }, options);
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this.track);
        this.update();
      }

      direction() {
        return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      }

      maximum() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      behavior() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      }

      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * this.direction() * (card.getBoundingClientRect().width + gap), behavior: this.behavior() });
      }

      update() {
        const maximum = this.maximum();
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = maximum <= 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sesseq-weekly-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sesseq-weekly-story')) {
    customElements.define('sesseq-weekly-story', class extends HTMLElement {
      connectedCallback() {
        this.stories = [...this.querySelectorAll('template[data-story-id]')];
        this.active = this.querySelector('.sws__active');
        this.abort = new AbortController();
        this.refresh();
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refresh(); }, { signal: this.abort.signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.stories.findIndex(story => story.dataset.storyId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
      refresh() {
        if (this.dataset.autoRotate !== 'true' || !this.stories.length) return;
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).map(part => [part.type, part.value]));
        const today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
        const start = Date.parse(this.dataset.startDate + 'T00:00:00Z');
        if (!Number.isFinite(start)) return;
        const week = Math.max(0, Math.floor((today - start) / 604800000));
        this.show(week % this.stories.length);
      }
      show(index) {
        if (!this.active || !this.stories[index] || Number(this.dataset.activeIndex) === index) return;
        this.active.replaceChildren(this.stories[index].content.cloneNode(true));
        this.dataset.activeIndex = String(index);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
